import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-column align-items-center w-full gap-3 surface-border" }
const _hoisted_2 = { class: "white-space" }
const _hoisted_3 = {
  key: 0,
  class: "lead text-muted"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Store Name:", -1)
const _hoisted_5 = { class: "lead text-muted" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "User Role:", -1)
const _hoisted_7 = {
  key: 1,
  class: "lead text-muted"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Enterprise Name:", -1)

import { useAuth0 } from "@auth0/auth0-vue";
import ApiService from '../service/api.service';
import { onBeforeMount } from 'vue';
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  name: 'MyProfile',
  setup(__props) {

const storeid = ref('');
const role = ref('');
const selectedEnterpriseStore = ref();
const enterprisestores = ref([]);
const store = useStore();
const auth0 = useAuth0();
const enterpriseid = ref('');
const storename = ref('');
const enterprisename = ref('');

onBeforeMount(async () => {
  role.value = store.state.role;
  storeid.value = store.state.storeid;
  enterpriseid.value = store.state.enterpriseid;
  storename.value = store.state.storename;

  if (role.value == 'EnterpriseAdmin') {
    const accessToken = await auth0.getAccessTokenSilently();
    enterprisename.value = await ApiService.getEnterpriseNameById(accessToken, enterpriseid.value);
    enterprisestores.value = store.state.enterprisestores;
    selectedEnterpriseStore.value = enterprisestores.value.find(item => item.StoreId == storeid.value);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createVNode(_component_ConfirmDialog, { group: "templating" }, {
      message: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(slotProps.message.message), 1)
        ])
      ]),
      _: 1
    }),
    (storename.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(storename.value), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_5, [
      _hoisted_6,
      _createTextVNode(" " + _toDisplayString(role.value), 1)
    ]),
    (role.value === 'EnterpriseAdmin')
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(" " + _toDisplayString(enterprisename.value), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})